import { migraine1stLine } from './migraine1stLine';
import { migraine2ndLine } from './migraine2ndLine';
import { migraine3rdLine } from './migraine3rdLine';

const MigraineFlows = {
  migraine1stLine,
  migraine2ndLine,
  migraine3rdLine
};

export default MigraineFlows;
